import { html, nothing } from 'lit/html.js';
import { styleMap } from 'lit/directives/style-map.js';

/**
 * Renders a hidden link element if a URL is provided.
 * This ensures that right-click context menu contains the <a> build in options such as 'open the link in a new tab'.
 *
 * @param {string} url - The URL to be used for the hidden link.
 * @returns {TemplateResult | typeof nothing} - The rendered template or nothing if no URL is provided.
 */
export const renderHideLink = (url, target) => {
  const styles = {
    content: '',
    position: 'absolute',
    zIndex: 2,
    inset: 0,
  };

  if (url) {
    return html`<a
      href="${url}"
      tabindex="-1"
      id="hideLink"
      aria-hidden="true"
      style=${styleMap(styles)}
      target=${target}
    ></a>`;
  }
  return nothing;
};
